import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/laba.png';
const _withScopeId = n => (_pushScopeId("data-v-7337fe3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1,
  class: "css9"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  class: "css8"
};
const _hoisted_6 = {
  id: "scroll",
  ref: "scroll",
  class: "css7"
};
const _hoisted_7 = {
  class: "flex"
};
const _hoisted_8 = {
  class: "css6"
};
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  style: {
    "width": "15px",
    "height": "15px"
  }
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "background-color": "#ececec",
    "margin-top": "3px"
  }
}, null, -1));
const _hoisted_11 = {
  style: {
    "margin-top": "5px",
    "margin-bottom": "5px",
    "color": "#032b72"
  }
};
const _hoisted_12 = {
  class: "flex"
};
const _hoisted_13 = {
  style: {
    "color": "rgb(3, 43, 114)",
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_14 = {
  key: 0,
  src: _imports_0,
  style: {
    "margin-left": "5px",
    "width": "15px",
    "height": "15px"
  }
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "background-color": "#ececec",
    "margin-top": "3px"
  }
}, null, -1));
const _hoisted_16 = {
  style: {
    "height": "20px"
  },
  class: "flex align-center"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 0,
  style: {
    "margin-top": "5px",
    "margin-bottom": "5px"
  }
};
const _hoisted_19 = {
  style: {
    "text-align": "left",
    "width": "fit-content"
  }
};
const _hoisted_20 = {
  key: 0,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#9f35f9"
  }
};
const _hoisted_21 = {
  key: 1,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#f2460a"
  }
};
const _hoisted_22 = {
  key: 1,
  style: {
    "font-style": "italic"
  }
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "2px",
    "background-color": "#ccc",
    "margin-top": "3px"
  }
}, null, -1));
const _hoisted_24 = {
  style: {
    "margin-left": "5px",
    "margin-right": "5px"
  }
};
const _hoisted_25 = {
  style: {
    "width": "90%",
    "padding-left": "5px",
    "padding-top": "5px"
  }
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原型:", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_29 = {
  key: 0,
  style: {
    "color": "#485860"
  }
};
const _hoisted_30 = {
  style: {
    "text-align": "left",
    "width": "fit-content"
  }
};
const _hoisted_31 = {
  key: 0,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#9f35f9"
  }
};
const _hoisted_32 = {
  key: 1,
  style: {
    "font-size": "0.6rem",
    "color": "#ffffff",
    "background-color": "#f2460a"
  }
};
const _hoisted_33 = {
  class: "flex"
};
const _hoisted_34 = {
  class: "css3"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "background-color": "#ececec",
    "margin-top": "3px"
  }
}, null, -1));
import { watch, ref, nextTick, computed } from "vue";
import record from "../record/record.vue";
import analyse from "../analyse/analyse.vue";
import { useStore, defineExpose } from "vuex";
import { getLocalPid } from "../../../libs/util";
import { ElMessage } from "element-plus";
import { bizTts, urlService, translate } from "../../../api/index";
import { useRouter } from "vue-router";
export default {
  __name: 'popup',
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: 0
    },
    articleId: {
      type: [Number, String],
      default: 0
    },
    readLogId: {
      type: [Number, String],
      default: 0
    }
  },
  emits: ["noPopup", "close", "noPopup", "menuItemClick"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const store = useStore();
    const emit = __emit;
    const sentence = computed(() => {
      return store.state.sentence;
    });
    const word = computed(() => {
      return store.state.word;
    });
    const offset = computed(() => {
      return store.state.offset;
    });
    const safeMes = computed(() => {
      return store.state.safeMes;
    });
    const recordRef = ref(null);
    const router = useRouter();
    const props = __props;
    const status = ref(false);
    const left = ref(0);
    const top = ref(0);
    const analyseVis = ref(false);
    const translateVis = ref(false);
    const wordVis = ref(false);
    const translateVal = ref("");
    const menuVis = ref(true);
    const audioUrl = ref("");
    const recordVis = ref(false);
    let spk = false;
    let ison = false;
    let odl = null;
    let maxX = 0;
    const stopRecord = ref(false);
    let justTrans = false;
    watch(audioUrl, newValue => {
      if (newValue == "") return;
      if (spk) toSpeak();
    });
    const toView = () => {
      setTimeout(() => {
        window.scrollTo(0, top.value + 50);
      }, 100);
    };
    const allHide = () => {
      if (translateVis.value || wordVis.value || analyseVis.value || recordVis.value) {
        secondHide();
      } else {
        hide();
      }
    };
    const hide = () => {
      if (translateVis.value) return;
      if (wordVis.value) return;
      if (analyseVis.value) return;
      if (recordVis.value) return;
      status.value = false;
      menuVis.value = true;
      ison = false;
      emit("noPopup");
      justTrans = false;
      emit("close");
    };
    const secondHide = () => {
      if (recordVis.value) {
        recordRef.value.stop();
      }
      translateVis.value = false;
      analyseVis.value = false;
      wordVis.value = false;
      status.value = false;
      menuVis.value = true;
      recordVis.value = false;
      spk = false;
      ison = false;
      if (odl) odl.pause();
      emit("noPopup");
      stopRecord.value = false;
      justTrans = false;
      emit("close");
    };
    const popEvent = async item => {
      switch (item.event) {
        case "search":
          wordVis.value = true;
          getTranslate();
          break;
        case "teacher":
          if (!safeMes.value.sign) {
            ElMessage.warning("登录后才能使用这些功能哦");
            break;
          }
          getTeacherAddress();
          break;
        case "analyse":
          menuVis.value = false;
          await nextTick();
          analyseVis.value = true;
          break;
        case "translate":
          justTrans = true;
          translateVis.value = true;
          getTranslate();
          break;
        case "speak":
          translateVis.value = true;
          getTranslate(1);
          break;
        case "record":
          if (!safeMes.value.sign) {
            ElMessage.warning("登录后才能使用这些功能哦");
            break;
          }
          menuVis.value = false;
          recordVis.value = true;
          break;
        default:
          hide();
          emit("menuItemClick", item);
          break;
      }
    };
    const getTranslate = (type = 0) => {
      audioUrl.value = "";
      translateVal.value = null;
      menuVis.value = false;
      if (type) {
        spk = true;
        return getSpeaker();
      }
      let obj = {
        ...safeMes.value,
        articleId: props.articleId - 0,
        readLogId: props.readLogId - 0,
        content: translateVis.value ? sentence.value : word.value,
        sentence: translateVis.value ? "" : sentence.value,
        offset: translateVis.value ? 0 : offset.value - 0
      };
      console.log(obj);
      translate(encodeURIComponent(JSON.stringify(obj))).then(v => {
        console.log(v);
        if (v.data.code) return store.commit("judgeCode", {
          code: v.data.code,
          msg: v.data.msg
        });
        const data = v.data.data;
        console.log(data);
        translateVal.value = data.sentenceResult ? data.sentenceResult.translate : data.wordResult;
        console.log(translateVal.value);
        console.log("-----------------");
        if (!justTrans) getSpeaker();
      }).catch(err => {
        console.log(err);
        ElMessage.error(err);
      });
    };
    const getSpeaker = () => {
      try {
        menuVis.value = false;
        let obj = {
          ...safeMes.value,
          articleId: props.articleId - 0,
          readLogId: props.readLogId - 0,
          content: translateVis.value ? sentence.value : word.value
        };
        bizTts(encodeURIComponent(JSON.stringify(obj))).then(v => {
          if (v.data.code) return store.commit("judgeCode", {
            code: v.data.code,
            msg: v.data.msg
          });
          audioUrl.value = v.data.data.audioUrl;
        }).catch(err => {
          ElMessage.error(err);
        });
      } catch (err) {
        ElMessage.error(JSON.stringify(err) + "1");
      }
    };
    // eslint-disable-next-line no-unused-vars
    const show = (v1, v2) => {
      maxX = document.body.clientWidth - props.width;
      left.value = v1 > maxX ? maxX / 2 : v1;
      top.value = v2;
      status.value = true;
    };
    const toSpeak = () => {
      if (!ison) {
        try {
          odl = new Audio();
          odl.src = audioUrl.value;
          odl.play();
          ison = true;
          odl.addEventListener("ended", () => {
            ison = false;
          });
        } catch (err) {
          ElMessage.error(JSON.stringify(err));
        }
      }
    };
    const getTeacherAddress = () => {
      let obj = {
        ...safeMes.value,
        pid: getLocalPid()
      };
      urlService(encodeURIComponent(JSON.stringify(obj))).then(v => {
        if (v.data.code === 10015) return router.push("/teacher");
        if (v.data.code) return ElMessage.error(v.data.msg);
        if (v.data) {
          window.location.href = v.data.data;
        }
      }).catch(err => {
        return ElMessage.error(err + " 获取名师地址失败 ");
      });
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      return status.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [menuVis.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle('left:' + left.value + 'px;top:' + (top.value + 5) + 'px;width:' + __props.width + 'px;'),
        class: "flex align-center items css1"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "width": "48%"
          }
        }, [_createElementVNode("div", {
          class: "flex text-white align-center justify-center css11",
          onClick: $event => popEvent(item)
        }, _toDisplayString(item.name), 9, _hoisted_2)]);
      }), 128))], 4)) : _createCommentVNode("", true), _createElementVNode("div", {
        onClick: allHide,
        class: "css10"
      }), analyseVis.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(sentence.value), 1)]), _createElementVNode("div", _hoisted_6, null, 512), _createVNode(analyse, {
        articleId: __props.articleId,
        readLogId: __props.readLogId,
        type: 'component',
        bodyStyle: 'flex-1;',
        onToView: toView
      }, null, 8, ["articleId", "readLogId"])])])) : _createCommentVNode("", true), translateVis.value ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "css4",
        style: _normalizeStyle('left:' + left.value + 'px;top:' + (top.value + 5) + 'px;width:' + __props.width + 'px;')
      }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createTextVNode(_toDisplayString(sentence.value) + " ", 1), _createElementVNode("span", {
        style: {
          "display": "flex",
          "align-items": "center",
          "flex": "0 0 30px",
          "height": "20px"
        },
        onClick: toSpeak
      }, [audioUrl.value ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true)])])]), _hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(translateVal.value), 1)], 4)) : _createCommentVNode("", true), wordVis.value ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "css5",
        style: _normalizeStyle('left:' + left.value + 'px;top:' + (top.value + 5) + 'px;width:' + __props.width + 'px;')
      }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(word.value), 1), _createElementVNode("div", {
        style: {
          "display": "flex",
          "align-items": "center",
          "width": "40px",
          "height": "20px"
        },
        onClick: toSpeak
      }, [audioUrl.value ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _createCommentVNode("", true)])]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_createTextVNode(" ["), translateVal.value && translateVal.value.phonetic ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(translateVal.value.phonetic), 1)) : _createCommentVNode("", true), _createTextVNode("] ")]), translateVal.value && translateVal.value.translations ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translateVal.value.translationsV2, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "color": "#032b72",
            "border-bottom-color": "#dddddd",
            "border-bottom-style": "dashed",
            "border-bottom-width": "0.05rem",
            "padding": "1px"
          }
        }, [_createElementVNode("div", _hoisted_19, [item.isVariant ? (_openBlock(), _createElementBlock("span", _hoisted_20, "↓词性要点")) : item.bestIndexes.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_21, "↓最佳解释")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("span", {
          style: _normalizeStyle(item.bestIndexes.length > 0 ? 'color: #f2460a;' : '')
        }, _toDisplayString(item.pos), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.explains, (explain, idxL2) => {
          return _openBlock(), _createElementBlock("span", {
            key: idxL2
          }, [idxL2 > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(",")], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
            style: _normalizeStyle(item.isVariant ? 'color:#9f35f9;' : item.bestIndexes.indexOf(idxL2) != -1 ? 'color: #f2460a;' : '')
          }, _toDisplayString(explain), 5)]);
        }), 128))])]);
      }), 128))])) : _createCommentVNode("", true), translateVal.value && translateVal.value.lemma ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _hoisted_27, _createElementVNode("span", null, _toDisplayString(translateVal.value.lemma.word), 1), _hoisted_28, translateVal.value.lemma.phonetic ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString("[ " + translateVal.value.lemma.phonetic + " ]"), 1)) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translateVal.value.lemma.translationsV2, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: {
            "color": "#032b72",
            "border-bottom-color": "#dddddd",
            "border-bottom-style": "dashed",
            "border-bottom-width": "0.05rem",
            "padding": "1px"
          }
        }, [_createElementVNode("div", _hoisted_30, [item.isVariant ? (_openBlock(), _createElementBlock("span", _hoisted_31, "↓词性要点")) : item.bestIndexes.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_32, "↓最佳解释")) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("span", {
          style: _normalizeStyle(item.bestIndexes.length > 0 ? 'color: #f2460a;' : '')
        }, _toDisplayString(item.pos), 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.explains, (explain, idxL2) => {
          return _openBlock(), _createElementBlock("span", {
            key: idxL2
          }, [idxL2 > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(",")], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
            style: _normalizeStyle(item.isVariant ? 'color:#9f35f9;' : item.bestIndexes.indexOf(idxL2) != -1 ? 'color: #f2460a;' : '')
          }, _toDisplayString(explain), 5)]);
        }), 128))])]);
      }), 128))])])) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true), recordVis.value ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "css2",
        style: _normalizeStyle('left:' + left.value + 'px;top:' + (top.value + 5) + 'px;width:' + __props.width + 'px;')
      }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(sentence.value), 1)]), _hoisted_35, _createVNode(record, {
        onSecondeHide: secondHide,
        ref_key: "recordRef",
        ref: recordRef,
        stopRecord: stopRecord.value
      }, null, 8, ["stopRecord"])], 4)) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};